import React from 'react';
import { MESSAGE_STATUSES } from '../../../constants/defaultValues';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeMessagesPage,
    changeMessagesSelectedStatus,
    getMessages,
} from '../../../store/actions/messages';

const Filter = () => {
    const dispatch = useDispatch();

    const { selectedStatus, pageSize } = useSelector(state => state.messages);

    const onStatusChange = status => {
        dispatch(changeMessagesSelectedStatus(status));
        dispatch(changeMessagesPage(1));
        dispatch(getMessages({ index: 0, status, size: pageSize }));
    };

    return (
        <nav className={'filters-nav'}>
            {MESSAGE_STATUSES.map(status => (
                <button
                    key={status.status}
                    className={`filter-tab ${status.status === selectedStatus ? 'active' : ''}`}
                    onClick={() => onStatusChange(status.status)}
                >
                    {status.name}
                </button>
            ))}
        </nav>
    );
};

export default Filter;
